export default {
	help: {
		faq: "FAQ",
		promo: "Promo",
		contactUs: "Contact Us",
		joinCommunity: "Join Our Community",
		help: "Help"
	}
};